import { GetterTree } from "vuex";
import { IJobState } from "@/store/modules/job/state";
import { Job } from "@/types";

import { IDataProvider, IRootState } from "@/store";

export enum JobGetters {
  GET_ALL = "GET_ALL_JOB",
  GET_CURRENT = "GET_CURRENT_JOB",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_JOB",
}

export const getters: GetterTree<IJobState, IRootState> = {
  [JobGetters.GET_ALL](state): Job[] | null {
    return state.jobs;
  },
  [JobGetters.GET_CURRENT](state): Job | null {
    return state.job;
  },
  [JobGetters.GET_DATA_PROVIDER](state): IDataProvider<Job> | null {
    return state.dataProvider;
  },
};
